// src/actions/reports/getVentasPorPeriodo.action.ts
import apiClient from "@/clients/apiClient";
import { ApiResponse } from "@/utils/ApiResponse";
import { VentasPeriodoInterface } from "../interfaces/ventasPeriodo.interface";


export async function getVentasPorPeriodoAction(
  fechaInicio: string,
  fechaFin: string
): Promise<ApiResponse<VentasPeriodoInterface>> {
  const { data } = await apiClient.get<VentasPeriodoInterface>("reports/ventas/periodo", {
    params: { fechaInicio, fechaFin },
  });

  return {
    status: 200,
    data,
    message: "Ventas por período obtenidas correctamente",
  };
}